import styled from '@emotion/styled';
import { bodyM } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';
export const Option = styled.div`
  :hover {
    background-color: ${vars.neutral[5]};
  }
  display: flex;
  gap: 8px;
  cursor: pointer;
  ${bodyM};
  color: ${vars.neutral[70]};
  border-radius: 8px;
  padding: 10px 6px;
`;
